import { ajax } from '@ebay/presence-ui/lib/ajax-handler';
import { get, clone } from '@ebay/presence-ui/lib/object-helpers';
import { loadingSpinnerShow, loadingSpinnerHide } from '@ebay/presence-ui/lib/event-triggers';
import Page from '../../pages/page';

const AJAX_MODULE_UPDATE_EVENT = 'ajax-module-update-event';
const CATEGORY_FILTER_EVENT = 'categoryFilterEvent';
const SORT_LISTINGS_EVENT = 'sortListingsEvent';
const POPSTATE_UPDATE_EVENT = 'popstateUpdateEvent';
const AJAX_TIMEOUT = 10000;

export default class {
    onCreate(input, out) {
        this.defaultLanguage = get(out, 'global.req.locality.defaultLanguage');
        this.state = {
            page: input.page,
            globalState: {}
        };
    }
    onMount() {
        document.addEventListener(AJAX_MODULE_UPDATE_EVENT, evt => {
            this.updateModules({
                url: get(evt, 'detail.url'),
                updateEvent: get(evt, 'detail.updateEvent'),
                type: get(evt, 'detail.type'),
                spinnerId: get(evt, 'detail.spinnerId'),
                errorCallback: get(evt, 'detail.errorCallback'),
                successCallback: get(evt, 'detail.successCallback')
            });
        });
        window.addEventListener('popstate', (evt) => {
            const updateEvent = evt.state && evt.state.updateEvent;
            if (updateEvent) {
                const spinnerId = getSpinnerId(updateEvent);
                loadingSpinnerShow(spinnerId);
                this.updateModules({
                    url: window.location.href,
                    updateEvent: POPSTATE_UPDATE_EVENT,
                    spinnerId: spinnerId
                });
            }
        });
    }
    updateModules(cfg) {
        // Show spinner
        let spinnerId = cfg.spinnerId;
        if (!spinnerId) {
            spinnerId = getSpinnerId(cfg.updateEvent);
        }
        loadingSpinnerShow(spinnerId);

        // Get and update content
        const ajaxUrl = buildAjaxUrl(cfg.url);
        ajax({ url: ajaxUrl }, {
            successCallBack: (resp) => {
                if (this.isError(resp)) {
                    if (cfg.errorCallback) {
                        cfg.errorCallback();
                    }
                } else {
                    const page = new Page(resp);
                    if (hasCategoryParam(cfg.url) && cfg.type === 'marketingBannerType') {
                        document.dispatchEvent(new CustomEvent('scroll-to-sticky-top'));
                    }
                    updateModulesAndPositions(this.state, page, cfg.url, cfg.updateEvent);
                    if (cfg.successCallback) {
                        cfg.successCallback();
                    }
                }
                loadingSpinnerHide(spinnerId);
            },
            errorCallBack: () => {
                if (cfg.errorCallback) {
                    cfg.errorCallback();
                }
                loadingSpinnerHide(spinnerId);
            }
        },
        AJAX_TIMEOUT);
    }
    isError(resp) {
        return !!(!resp || resp.message || resp.stack); // Assumes resp.message and resp.stack are errors
    }
    setGlobalStateProperty(namespace, event) {
        const NSObject = this.state.globalState[namespace] || {};
        // Destructure cloning to prevent deep state changes to be ignored
        this.state.globalState = {
            ...this.state.globalState,
            [namespace]: {
                ...NSObject,
                [event.key]: event.partial ? {
                    ...(NSObject[event.key] || {}),
                    ...event.value
                } : event.value
            }
        };
    }
    static sendCategoryFilterEvent(cfg) {
        // Need to use links for the SEO, but for ajax, need to prevent the links from navigating.
        // clickEvent.originalEvent is from Marko tag. The other is from a regular HTML tag.
        const elEvent = get(cfg, 'clickEvent.originalEvent') || get(cfg, 'clickEvent');
        if (elEvent && elEvent.target.closest('A')) {
            elEvent.preventDefault();
        }

        const ajaxEvt = new CustomEvent(AJAX_MODULE_UPDATE_EVENT, {
            detail: {
                url: cfg.url,
                updateEvent: CATEGORY_FILTER_EVENT,
                type: cfg.type,
                spinnerId: cfg.spinnerId
            }
        });
        document.dispatchEvent(ajaxEvt);
    }
    static sendSortListingsEvent(cfg) {
        const ajaxEvt = new CustomEvent(AJAX_MODULE_UPDATE_EVENT, {
            detail: {
                url: cfg.url,
                updateEvent: SORT_LISTINGS_EVENT,
                errorCallback: cfg.errorCallback
            }
        });
        document.dispatchEvent(ajaxEvt);
    }
    static sendPaginateEvent(cfg) {
        const ajaxEvt = new CustomEvent(AJAX_MODULE_UPDATE_EVENT, {
            detail: {
                url: cfg.url,
                updateEvent: SORT_LISTINGS_EVENT,
                errorCallback: cfg.errorCallback,
                successCallback: cfg.successCallback
            }
        });
        document.dispatchEvent(ajaxEvt);
    }
}

function buildAjaxUrl(url) {
    const link = document.createElement('a');
    link.href = url;
    let queryString;

    if (link.search) {
        queryString = `${link.search}&_ajax=itemFilter`;
    } else {
        queryString = `?_ajax=itemFilter`;
    }

    return `${link.pathname}${queryString}`;
}

function hasCategoryParam(url) {
    return url.match(/_sacat=\d+|store_cat=\d+|_storecat=\d+/);
}

function updateModulesAndPositions(state, newPage, url, updateEvent) {
    const keys = Object.keys(get(newPage, 'modules'));
    if (keys.length) {
        const pageClone = clone(state.page);
        pageClone.modules = newPage.modules;
        const positionsReplaced = replaceTab0Positions(pageClone, newPage);
        if (positionsReplaced) {
            state.page = pageClone;
            updateWindowHistory(url, updateEvent);
        }
    }
}

function replaceTab0Positions(pageClone, newPage) {
    const listClone = get(pageClone, 'meta.pageTemplate.regions.TAB0.layouts.LIST_1_COLUMN');
    const newList = get(newPage, 'meta.pageTemplate.regions.TAB0.layouts.LIST_1_COLUMN');
    if (listClone && newList) {
        listClone.positions = newList.positions;
        return true;
    }
}

function updateWindowHistory(url, updateEvent) {
    if (url && updateEvent !== POPSTATE_UPDATE_EVENT) {
        try {
            const link = document.createElement('a');
            link.href = url;
            const newUrl = `${link.pathname}${link.search}${window.location.hash}`;
            window.history.replaceState({ updateEvent: updateEvent }, '');
            window.history.pushState({ updateEvent: updateEvent }, '', newUrl);
        } catch (err) {
            // console.log(err);
        }
    }
}

function getSpinnerId(updateEvent) {
    let spinnerId = 'tab0LoadingSpinner';
    if (updateEvent === SORT_LISTINGS_EVENT) {
        spinnerId = 'listingsLoadingSpinner';
    }
    return spinnerId;
}
